import { StartupActionCreator } from '../startup/startup.actioncreator';

export class DynamicsStartupActionCreator extends StartupActionCreator {
  public async startMainApplication(): Promise<void> {
    return super.startMainApplication();
    // retrieve and save organization ID
  }
}
